export default __webpack_public_path__ + "static/media/016-ramen.fb8c99cd.svg";